import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {setLastVisitedUrl} from '../store/appState/appStateSlice'; // create this action

const EXCLUDED_PATHS = ['/login', '/logout', '/login/callback', '/'];

export const RouteTracker = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const fullPath = location.pathname + location.search;

    if (!EXCLUDED_PATHS.includes(location.pathname)) {
      //FOR DEBUGING: console.log(`User navigated to: ${fullPath}`);
      dispatch(setLastVisitedUrl(fullPath));
    }
  }, [location, dispatch]);

  return null;
};
